import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { Input, message as $message, Spin, Button } from 'antd'
import LoadingOutlined from '@ant-design/icons/LoadingOutlined'

import styles from './index.less'

import { getImageCaptcha, getLoginImageCaptcha } from '@/services/captcha'

// isLogin 登录用， erp接口限制：loginName必传
export default forwardRef(
    ({ form, value, onChange, size, imgWidth, isLogin, getLoginName, showReloadBtn, ...restProps }, ref) => {
        const [src, setSrc] = useState('')
        const [preToken, setPreToken] = useState(undefined)
        const [loading, setLoading] = useState(false)

        const reload = async callback => {
            setLoading(true)

            try {
                const { success, message, data } = await (isLogin
                    ? getLoginImageCaptcha({ loginName: getLoginName() })
                    : getImageCaptcha())

                if (success) {
                    const { img, preToken } = data

                    setSrc(`data:image/png;base64,${img}`)

                    setPreToken(preToken)

                    typeof callback === 'function' && callback({ preToken })
                } else {
                    $message.error(message)
                }
            } catch (e) {
                console.error('catchError', e)
            }

            setLoading(false)
        }

        const reloadImgCode = () => {
            reload(({ preToken }) => {
                onChange({
                    preToken,
                    checkCode: ''
                })
            })
        }

        useImperativeHandle(ref, () => ({
            reload: reloadImgCode
        }))

        if (form) {
            form.reloadImgCode = reloadImgCode
        }

        useEffect(() => {
            reload()
        }, [])

        const sizeStyle = {
            height: size === 'large' ? '40px' : '30px',
            width: imgWidth || '100px'
        }

        const btnStyle = {
            height: size === 'large' ? '40px' : '30px'
        }

        return (
            <div className={styles.container}>
                <Input
                    allowClear={false}
                    className={styles.lt}
                    size={size}
                    {...restProps}
                    value={value && value.checkCode}
                    placeholder="请输入图形验证码"
                    maxLength={4}
                    onChange={({ target: { value: checkCode } }) =>
                        onChange({
                            preToken,
                            checkCode
                        })
                    }
                />

                <Spin size="small" spinning={loading} indicator={<LoadingOutlined style={{ color: '#999' }} spin />}>
                    <div className={styles.rt} style={sizeStyle} onClick={reload}>
                        {src ? <img className={styles.img} src={src} alt="" style={sizeStyle} /> : null}
                    </div>
                </Spin>

                {showReloadBtn ? (
                    <Button onClick={reload} style={btnStyle} className={styles.reload} type="link">
                        换一张
                    </Button>
                ) : null}
            </div>
        )
    }
)
